// @flow
import {
  ADMIN_UPDATE_RESELLER_LIST, ADMIN_UPDATE_RESELLER_DETAIL
} from "../../global/actions/actionNames";

const initialState = {
  resellers: null
};

const resellerReducers = (state: Object = initialState, actions: Object) => {
  switch (actions.type) {

  case ADMIN_UPDATE_RESELLER_LIST:
    let resellers = state.resellers === null ? [] : [...state.resellers];
    if (actions.reseller !== null && actions.reseller.id !== null) {
      if(resellers.length > 0) {
        let index = resellers.findIndex(x => x.id === actions.reseller.id);
        if(index > -1){
          resellers[index] = actions.reseller;
        }
        else{
          resellers.push(actions.reseller);
        }
      }
      else{
        resellers.push(actions.reseller);
      }
    }
    return {
      ...state,
      resellers: resellers
    };

  case ADMIN_UPDATE_RESELLER_DETAIL:
    let reseller_list = state.resellers === null ? [] : [...state.resellers];
    if (actions.resellerId !== null && actions.fieldName !== null && actions.value !== null) {
      if(reseller_list.length > 0) {
        let index = reseller_list.findIndex(x => x.uuid === actions.resellerId);
        if(index > -1){
          let reseller = {...reseller_list[index]};
          reseller[actions.fieldName] = actions.value;
          reseller_list[index] = reseller;
        }
      }
    }
    return {
      ...state,
      resellers: reseller_list
    };

  default:
    return state;
  }
};
export default resellerReducers;